import { AutoComplete, Input, Select } from "antd";
import { useDebounce } from "Explore/Components";
import { getSuggestSearchAuthors } from "Explore/Services/Author";
import { getSuggestSearchConcepts } from "Explore/Services/Concept";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import { getSuggestSearchVenues } from "Explore/Services/Venue";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./HomeSearch.module.scss";

const HomeSearch = ({ searchDefault, setSearchDefault }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [facultySuggest, setFacultySuggest] = useState([]);
  const [institutionSuggest, setInstitutionSuggest] = useState([]);
  const [venueSuggest, setVenueSuggest] = useState([]);
  const [conceptSuggest, setConceptSuggest] = useState([]);
  const debouncedValue = useDebounce(query);

  useEffect(() => {
    if (debouncedValue) {
      if ((searchDefault == "all") & (debouncedValue !== "")) {
        getSuggestSearchAuthors(debouncedValue, (res) => {
          setFacultySuggest(res.slice(0, 3));
        });
        getSuggestSearchInstitutions(debouncedValue, (res) => {
          setInstitutionSuggest(res.slice(0, 3));
        });
        getSuggestSearchVenues(debouncedValue, (res) => {
          setVenueSuggest(res.slice(0, 3));
        });
        getSuggestSearchConcepts(debouncedValue, (res) => {
          setConceptSuggest(res.slice(0, 3));
        });
      } else if ((searchDefault == "faculty") & (debouncedValue !== "")) {
        getSuggestSearchAuthors(debouncedValue, (res) => {
          setFacultySuggest(res);
        });
      } else if ((searchDefault == "institution") & (debouncedValue !== "")) {
        getSuggestSearchInstitutions(debouncedValue, (res) => {
          setInstitutionSuggest(res);
        });
      } else if ((searchDefault == "venue") & (debouncedValue !== "")) {
        getSuggestSearchVenues(debouncedValue, (res) => {
          setVenueSuggest(res);
        });
      } else if ((searchDefault == "concept") & (debouncedValue !== "")) {
        getSuggestSearchConcepts(debouncedValue, (res) => {
          setConceptSuggest(res);
        });
      }
    }
  }, [debouncedValue]);

  const renderTitle = (title) => <span>{title}</span>;
  const renderConcept = (item) => ({
    value: item.value,
    id: item.id,
    entity: "concept",
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/explore/concept/${item.id}`);
          window.location.reload();
        }}
      >
        {item.value}
      </div>
    ),
  });
  const renderFaculty = (item) => ({
    value: item.name,
    entity: "faculty",
    id: item.explore_slug || item.id,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/explore/faculty/${item.explore_slug || item.id}`);
          window.location.reload();
        }}
      >
        {item.name} - {item.institution_name}
      </div>
    ),
  });

  const renderInstitution = (item) => ({
    value: item.name,
    entity: "institution",
    id: item.explore_slug || item.id,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/explore/institution/${item.explore_slug || item.id}`);
          window.location.reload();
        }}
      >
        {item.name}
      </div>
    ),
  });
  const renderVenue = (item) => ({
    value: item.name,
    entity: "venue",
    id: item.id,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/explore/venue/${item.id}`);
          window.location.reload();
        }}
      >
        {item.name}
      </div>
    ),
  });
  let options;
  if (searchDefault == "all") {
    options = [
      {
        label: renderTitle("Faculty"),
        options: facultySuggest.map((item) => renderFaculty(item)),
      },
      {
        label: renderTitle("Institution"),
        options: institutionSuggest.map((item) => renderInstitution(item)),
      },
      {
        label: renderTitle("Venue"),
        options: venueSuggest.map((item) => renderVenue(item)),
      },
      {
        label: renderTitle("Keyword"),
        options: conceptSuggest.map((item) => renderConcept(item)),
      },
    ];
  } else if (searchDefault == "faculty") {
    options = facultySuggest.map((item) => renderFaculty(item));
  } else if (searchDefault == "institution") {
    options = institutionSuggest.map((item) => renderInstitution(item));
  } else if (searchDefault == "venue") {
    options = venueSuggest.map((item) => renderVenue(item));
  } else if (searchDefault == "concept") {
    options = conceptSuggest.map((item) => renderConcept(item));
  }

  const handleChangeSearch = (value) => {
    setSearchDefault(value);
  };
  const handleSelectItem = (value, option) => {
    navigate(`/explore/${searchDefault}/${option.id}`);
  };

  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleInputMobile = (e) => {
    setQuery(e.target.value);
  };
  return (
    <div className={styles["home-search"]}>
      <p>Discover more</p>
      <div className={styles["search"]}>
        <div className={styles["search-bar"]}>
          <AutoComplete
            popupClassName="certain-category-search-dropdown"
            popupMatchSelectWidth="100%"
            options={options}
            onChange={handleInputChange}
            onSelect={handleSelectItem}
            style={{ width: "100%" }}
          >
            <Input
              placeholder="Type to search"
              className={styles["input-search"]}
              onPressEnter={() =>
                navigate(`/explore/${searchDefault}/?query=${query}`)
              }
            />
          </AutoComplete>
        </div>
        <Select
          value={searchDefault}
          placeholder="Borderless"
          variant="borderless"
          style={{
            flex: 1,
          }}
          onChange={handleChangeSearch}
          options={[
            {
              value: "faculty",
              label: "Faculty",
            },
            {
              value: "institution",
              label: "Institution",
            },
            {
              value: "unit",
              label: "Unit",
            },
            {
              value: "venue",
              label: "Venue",
            },
            {
              value: "concept",
              label: "Concept",
            },
          ]}
        />
      </div>
      <div className={styles["search-mobile"]}>
        <div className={styles["search-bar"]}>
          <Input
            placeholder="Type to search"
            className={styles["input-search"]}
            onChange={handleInputMobile}
            onPressEnter={() =>
              navigate(`/explore/${searchDefault}/?query=${query}`)
            }
          />
        </div>
        <Select
          value={searchDefault}
          placeholder="Borderless"
          variant="borderless"
          style={{
            flex: 1,
          }}
          onChange={handleChangeSearch}
          options={[
            {
              value: "faculty",
              label: "Faculty",
            },
            {
              value: "institution",
              label: "Institution",
            },
            {
              value: "unit",
              label: "Unit",
            },
            {
              value: "venue",
              label: "Venue",
            },
            {
              value: "concept",
              label: "Concept",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default HomeSearch;
